export default {
  footer:
    ' Each sectors include all tickers from HOSE, HNX and UPCOM. (Sector value proportion is calculated base on total match value.)',
  listTimeRangeChartByKey: {
    Daily: 'Daily',
    Weekly: 'Weekly',
    Monthly: 'Monthly',
  },
  chartConfig: {
    chartTitle: 'NET VALUE BY INVESTOR',
    tooltipIndividual: 'Net Individual Value : {0} Bn.',
    tooltipInstitution: 'Net Local Institution Value : {0} Bn.',
    tooltipProprietary: 'Net Proprietary Value : {0} Bn.',
    tooltipForeign: 'Net Foreign Value : {0} Bn.',
    inforPrice: '{0} : {1} ',
    category: 'Time : {0}',
    legendIndividual: 'Individual',
    legendInstitution: 'Local Institution',
    legendProprietary: 'Proprietary',
    legendForeign: 'Foreign',
    legendCode: 'Price',
    yAxis1Title: 'Billion VND',
    yAxis2Title: 'Price Index',
  },
  dealValue: 'Matched Value',
  matchValue: 'Deal Value',
  totalValue: 'Total Value',
  timeRangeTable: {
    ONE_DAY: '1 DAY',
    FIVE_DAY: '5 DAYS',
    TWENTY_DAY: '20 DAYS',
    YTD: 'YTD',
  },
  timeRangeTableExport: {
    ONE_DAY: 'TODAY',
    FIVE_DAY: '5D',
    TWENTY_DAY: '20D',
    YTD: 'YTD',
  },
  rightLabel: 'Value Contribution (%)',
  listTitleTable: {
    ICB_NAME: 'SECTOR',
    CLOSE_INDEX: 'LAST',
    PERCENT_INDEX_CHANGE: '% CHANGE',
    INDIVIDUAL: 'Net Local Individual Value',
    INSTITUTION: 'Net Local Institution Value',
    PROPRIETARY: 'Net Proprietary Value',
    FOREIGN: 'Net Foreign Value',
  },

  INDIVIDUAL: 'Individual',
  INSTITUTION: 'Local Institution',
  PROPRIETARY: 'Proprietary',
  FOREIGN: 'Foreign',

  tooltipDate: 'The data is calculated from %{from} to %{to}',
  tooltipToday: 'The data is caculated as of %{from}',
  tooltipInvestorToday:
    ' is caculated as of %{from}. Data is only for Hose exchange.',
  tooltipInvestorDate:
    ' is calculated from %{from} to %{to}. Data is only for Hose exchange.',
  tooltipHose: 'Value: x 1,000,000. Statistic by Investors industrial data',
  // statInvestorNotice: {
  //   title: 'Notice',
  //   content:
  //     'From March, 1st, 2022; Proprietary Data is included in Local Institutional Data.',
  // },
};
